export const APPOINTMENT_CANCEL_REASONS = [
  { code: "hasta", label: "Hasta" },
  { code: "calisiyor", label: "Çalışıyor" },
  { code: "arac_arizasi", label: "Araç Arızası" },
  { code: "hava_kosullari", label: "Hava Koşulları" },
  { code: "cenaze", label: "Cenaze" },
  { code: "diger", label: "Diğer" },
] as const;

export type AppointmentCancelReasonCode = (typeof APPOINTMENT_CANCEL_REASONS)[number]["code"];

export function cancelReasonLabel(code: string): string {
  return APPOINTMENT_CANCEL_REASONS.find((r) => r.code === code)?.label || code;
}
